import { Redirect, Route, Switch } from 'react-router-dom';
import AcceptPolicies from '../containers/onboarding/accept-policies';
import { ROUTE_PATH } from './route-paths';
import TrustedSignup from '../containers/signup/trusted-signup';

export const TermsAndConditionsRouter = () => {
  return (
    <Switch>
      <Route path={ROUTE_PATH.ACCEPT_POLICIES} component={AcceptPolicies} />
      <Route exact path="/trusted-signup/:packageCode" component={TrustedSignup} />
      <Route exact path="*" render={() => <Redirect to={ROUTE_PATH.ACCEPT_POLICIES} />} />
    </Switch>
  );
};
